/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useLiveNotificationsPolling_viewer = {
    readonly id: string;
    readonly inPageNotifications: {
        readonly enabled: boolean;
    };
    readonly " $refType": "useLiveNotificationsPolling_viewer";
};
export type useLiveNotificationsPolling_viewer$data = useLiveNotificationsPolling_viewer;
export type useLiveNotificationsPolling_viewer$key = {
    readonly " $data"?: useLiveNotificationsPolling_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"useLiveNotificationsPolling_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLiveNotificationsPolling_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserInPageNotificationSettings",
            "kind": "LinkedField",
            "name": "inPageNotifications",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '1efe3a893ca71a9927c4fac3b2b3242d';
export default node;
